<template>
    <div class="flex flex-row items-center">
        <clock-icon :fillClass="'fill-primary'" class="mr-3" />
        <div class="text-lg font-semibold text-primary">
            {{ GET_CURRENT_TIME }}
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
} from "@vue/runtime-core";
import ClockIcon from "../icons/ClockIcon.vue";
export default defineComponent({
    components: { ClockIcon },
    props: {
        endTime: { type: Number, required: true },
    },
    name: "Counter",
    setup(props) {
        /**
         *  State
         */
        const state = reactive({
            runTime: 0,
        });

        /**
         *  Functions
         */
        function convertTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60);
            var hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (hours != 0) {
                if (minutes <= 10) {
                    minutes = "0" + minutes;
                }
                return hours + ":" + minutes + ":" + seconds;
            } else {
                return minutes + ":" + seconds;
            }
        }
        /**
         *  Computed
         */
        const GET_CURRENT_TIME = computed(() => {
            if (props.endTime - state.runTime < 0) {
                return convertTime(0);
            } else {
                return convertTime(props.endTime - state.runTime);
            }
        });

        /**
         *  Created
         */
        onMounted(() => {
            setInterval(() => {
                state.runTime++;
            }, 1000);
        });
        return {
            state,
            GET_CURRENT_TIME,
        };
    },
});
</script>
